import { render, staticRenderFns } from "./ProviderPanel.vue?vue&type=template&id=2ef2ea54&"
import script from "./ProviderPanel.vue?vue&type=script&lang=js&"
export * from "./ProviderPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports